<template>
  <BaseModal overlay-class="how_to_win">
    <div class="content">
      <BaseImage src="/static/images/other/howtowin_icon.svg" alt="how to win"/>

      <h3 class="title">{{ $_translations.value.modal_how_to_win_title }}</h3>

      <p>{{ $_translations.value.modal_how_to_win_description }}</p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
</script>
